// extracted by mini-css-extract-plugin
export default {"spinner":"LoadingSpinner_spinner__Q1vlO","loading":"LoadingSpinner_loading__wAGbq"};